const DiscoverySettings = {
  SHOW_CHALLENGES: "showChallenges"
};

export default DiscoverySettings;
